import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { ImageOff } from "lucide-react";

// Renders a real image, or a neutral charcoal placeholder block when no URL.
// NEVER falls back to stock/AI imagery — respects the "real images only" rule.
export const ImageBlock = ({ src, alt, className = "", overlay = false, testid }) => {
  const { t } = useLang();
  if (src) {
    return (
      <div className={`relative overflow-hidden ${className}`} data-testid={testid}>
        <img src={src} alt={alt} className="w-full h-full object-cover" loading="lazy" />
        {overlay && (
          <div className="absolute inset-0 bg-gradient-to-t from-charcoal/80 via-charcoal/10 to-transparent" />
        )}
      </div>
    );
  }
  return (
    <div
      className={`relative flex flex-col items-center justify-center bg-charcoal-light border border-gold/20 ${className}`}
      data-testid={testid}
    >
      <div className="flex flex-col items-center gap-3 text-center px-4 py-8">
        <ImageOff className="w-7 h-7 text-gold/50" strokeWidth={1.2} />
        <span className="text-[11px] uppercase tracking-[0.25em] text-gold/60 font-sans">
          {t("common.imageComingSoon")}
        </span>
        {alt && <span className="text-xs text-cream/40 font-sans max-w-[80%]">{alt}</span>}
      </div>
    </div>
  );
};
